<template>
  <div class="my">
    <ul>
      <li
        class="border-box"
        v-for="item in list"
        :key="item.id"
        @click="goDetail(item)"
      >
        <div class="list">
          <span>预约人姓名</span>
          <span>{{ item.name }}</span>
        </div>
        <div class="list">
          <span>证件类型</span>
          <span>{{ idType[item.idType] }}</span>
        </div>
        <div class="list">
          <span>证件编号</span>
          <span>{{ item.idCard }}</span>
        </div>
        <div class="list">
          <span>联系手机</span>
          <span>{{ item.telephone }}</span>
        </div>
        <div class="list">
          <span>同行人数</span>
          <span>{{ item.peopleNumber }}</span>
        </div>
        <div class="list">
          <span>祭祀区域</span>
          <span>{{ type[item.sacrificeType] }}</span>
        </div>
        <div class="list">
          <span>祭祀位号</span>
          <span>{{ item.sacrificeName }}</span>
        </div>
        <div class="list">
          <span>预约时间</span>
          <span>{{ item.sacrificeTime }}</span>
        </div>
        <div class="list">
          <span>预约时段</span>
          <span>{{ time[item.timeInterval] }}</span>
        </div>
        <div class="list">
          <span>预约状态</span>
          <span style="color: red;">{{ item.status === '1' ? '预约成功' : (item.status === '2' ? '预约中' : '取消预约') }}</span>
        </div>
        <div style="text-align:right" v-if="item.status !== '3'">
          <van-button type="info" @click.stop="cancal(item)"
            >取消预约</van-button
          >
        </div>
      </li>
      <van-empty
        v-if="list.length === 0"
        description="暂无预约数据"
        style="background-color:#fff;margin-top:33%"
      />
      <!-- <li class="border-box">
        <div class="list">
          <span>祭祀类型</span>
          <span>骨灰祭祀</span>
        </div>
        <div class="list">
          <span>联系人</span>
          <span>张三</span>
        </div>
        <div class="list">
          <span>身份证号</span>
          <span>8888888888888888</span>
        </div>
        <div class="list">
          <span>手机号</span>
          <span>132292928</span>
        </div>
        <div class="list">
          <span>人数</span>
          <span>3</span>
        </div>
        <div class="list">
          <span>祭祀号位</span>
          <span>2</span>
        </div>
        <div class="list">
          <span>祭祀时间</span>
          <span>2020年4月1日</span>
        </div>
        <div class="list">
          <span>时段</span>
          <span>2020年4月1日</span>
        </div>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { Dialog, Notify } from "vant";
export default {
  data() {
    return {
      list: [],
      time: {
        1: "8:30-10:00",
        2: "10:00-11:30",
        3: "11:30-13:00",
        4: "13:00-14:30",
        5: "14:30-16:00"
      },
      type: {
        "1": "骨灰祭祀",
        "2": "墓区",
        "3": "地载阁",
        "4": "露泽阁"
      },
      idType: {
        "1": "身份证",
        "2": "回乡证",
        "3": "军人证",
        "4": "其他"
      }
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$server.appointment
        .queryPage({ openid: this.$store.state.user.openid })
        .then(res => {
          if (res.code === "0") {
            this.list = res.list;
            console.log(this.list);
          }
        });
    },
    goDetail(item) {
      this.$router.push({
        path: "/show",
        query: {
          id: item.id
        }
      });
    },
    cancal(item) {
      Dialog.confirm({
        message: "是否确认取消预约",
        confirmButtonColor: "cornflowerblue",
        cancelButtonText: "取消"
      })
        .then(() => {
          // on confirm
          const params = {
            openid: this.$store.state.user.openid,
            id: item.id
          };
          this.$server.appointment.cancel(params).then(res => {
            if (res.code === "0") {
              this.getList();
            } else {
              Notify({ type: "danger", message: res.message });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="less" scoped>
.my {
  background-color: #f6faf9;
  .border-box {
    margin-bottom: 10px;
    background: #fff;
  }
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    &-count {
      color: #1677ff;
    }
    .van-cell {
      border: 1px solid #000000;
      border-radius: 5px;
      width: 70%;
      padding: 7px 16px;
    }
  }
}
</style>
